import _ from 'lodash'
import axios from '../../../common/axios.js'

export default {
	date(){
		return {
			inex_general_cancelSearch: null
		}
	},
	created(){
		
	},
	methods: {
		getSearch_inex_general(){
			let self = this

			//AS--> S'il n'y a pas de pays sélectionné pour la recherche iNex, on ne fait pas de recherche
			if(!this.$store.state.ui.sourcing.barre_recherches_limitpays && !this.$store.state.ui.sourcing.barre_recherches_affiche_pays) return

			if (this.inex_general_cancelSearch) this.inex_general_cancelSearch.cancel('Start new search, stop active search');
			this.inex_general_cancelSearch = axios.CancelToken.source();

			// console.log('getSearch_inex_general')
			this.updateState('inex_general', 'loading')

			let url = 'api=inex/search/{view_code}?label='+this.search_term
			if(this.$store.state.ui.sourcing.barre_recherches_limitpays) 	url += '&target_country='+this.$store.state.ui.sourcing.barre_recherches_limitpays
			if(this.$store.state.ui.sourcing.barre_recherches_affiche_pays) url += '&return_countries='+this.$store.state.ui.sourcing.barre_recherches_affiche_pays

			axios.get(url, { cancelToken: this.inex_general_cancelSearch.token })
			.then((response) => {
				console.log('response', response)

				//AS--> On ajoute les résultats à la liste
				self.addResults(_.cloneDeep(response.data))

			})
			.catch((error) => {
				console.log('error', error)
			})
			.finally(() => {
				this.updateState('inex_general', 'loaded')
			})

		}
	},
	computed:{
		
	},
	components:{
		
	}
}